import React, { useContext, useEffect, useState } from "react";
import ExpeditionsMain from "../images/expedition_banner.jpg";
import ExperiencesMain from "../images/experiences_banner.jpg";
import ExpeditionsMain_Mob from "../images/ExpeditionsMain_mobile.jpg";      
import ExperiencesMain_Mob from "../images/ExperiencesMain_mobile.jpg";    
import bottomarrow from "../images/down_arrow.png";
import Wrapper from "../components/wrapper/Wrapper";
import BoxItem from "../components/BoxItem";
import boxItemIgm1 from "../images/box_item_1.png";
import levelImg1 from "../images/cell_signal_1.png";
import FilterAccord from "../components/FilterAccord";
import { useParams } from "react-router-dom";
import { ThemeContext } from "../Context/Theme/Context";

const filterItems = [
  {
    id: 1,
    filterTitle: "DiffDifficulty Level",
    defaultShow: true,
  },
  {
    id: 2,
    filterTitle: "Location",
    defaultShow: false,
  },
  {
    id: 3,
    filterTitle: "Price",
    defaultShow: false,
  }
];

const Challenges = () => {
  const { title } = useParams()
  const { mainCategory } = useContext(ThemeContext)
  const [data, setData] = useState(filterItems);
  const [mainData, setMainData] = useState()

  useEffect(() => {
    const dd = title === "experiences" ? "experiences" : "expedtions"
    const data1 = mainCategory?.filter((item) => {
      return item.category === dd
    })
    setMainData(data1)
  }, [mainCategory, title])

  return (
    <>
      <Wrapper
        desktopImage={title === "expeditions" ? ExpeditionsMain : ExperiencesMain}
        mobileImage= {title === "expeditions" ? ExpeditionsMain_Mob : ExperiencesMain_Mob}
        firstTitle={title === "expeditions" ? "Raw & Iconic" : "in the heart of the himalayas"}

        bannerHeading={title}
        bansubheading="THAT ARE TIMELESS"
        scrolldown="scroll down"
        bottomarrow={bottomarrow}
        banpara={title === "expeditions" ? 'Venture into the raw wilderness of the Himalayas, where every trail is steeped in history. Set off on iconic expeditions that push your boundaries, offering breathtaking views and experiences that stay with you forever.' : 'Our  experiences embrace slow travel, offering a deep connection with the heart of the Himalayas. Immersive experiences highlight local culture, remote villages, and breathtaking landscapes. The journey is designed for reflection, with a relaxed pace to fully absorb the region’s magic'}
        topfootHead="Want Us To Recommend?"
        topfootPara="We're here to help you discover the right experience or tailor something that better suits your journey. Whatever your adventure, we've got you covered."
        bookCall="Book a Discovery Call"
      >
        <div className="container level_box_outer inner-container">
          <div className="row">
            <div className="col-md-4">
              {/* <div className="filter_section">
                <div className="pb-2">
                  <span> Filter  </span>
                </div>
                 {
                  data.map((curElem) => {
                    const { id } = curElem;
                    return <FilterAccord key={id} {...curElem} />
                  })
                } 
              </div> */}
            </div>

            <div name="test1" className="col-md-8">
              <div className="row">
                {mainData?.map((item) => {
                  return (
                    <>

                    
                      <BoxItem
                        levelShow={true}
                        imgSrc={item?.image ? process.env.react_app_base_url + "/" + item?.image : boxItemIgm1}
                        altTitle="box image 1"
                        date={item.date}
                        contentTitle={item?.title}
                        boxPara={""}
                        customClass="col-md-6"
                        circleBgColor="#E5EDFF"
                        levelImg={levelImg1}
                        levelTitle="Difficulty Level"
                        levelContent={item?.difficulty_level}
                        link={`/explore/${item?.category}/${item?.slug}`}
                      />
                    </>
                  )
                })}


              </div>
            </div>
          </div>
        </div>
      </Wrapper>
    </>
  )
};

export default Challenges;
